import { produce } from "immer";
import {
  ADD_FOLDER,
  ADD_FOLDER_FAILURE,
  ADD_FOLDER_SUCCESS,
  //
  UPDATE_CONTENT_FOLDERS,
  UPDATE_CONTENT_FILES,
  //
  DELETE_FOLDER,
  DELETE_FOLDER_FAILURE,
  DELETE_FOLDER_SUCCESS,
  //
  EDIT_FOLDER,
  EDIT_FOLDER_FAILURE,
  EDIT_FOLDER_SUCCESS,
  //
  FETCH_CONTENT,
  FETCH_CONTENT_FAILURE,
  FETCH_CONTENT_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  //
  VALIDATE_FILE,
  VALIDATE_FILE_SUCCESS,
  VALIDATE_FILE_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingContent: false,
  contentFolders: [],
  contentFiles: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentFolder: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  commentFilters: {
    page: 1,
    limit: 10,
    feed_id: "",
  },
  //
  commentCardMode: false,
  isUploadingFile: false,
  //
  isValidatingFile: false,
};

const FolderReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_CONTENT:
        draft.isFetchingContent = true;
        break;
      case FETCH_CONTENT_SUCCESS:
        draft.isFetchingContent = false;
        break;
      case FETCH_CONTENT_FAILURE:
        draft.isFetchingContent = false;
        break;

      case UPDATE_CONTENT_FOLDERS:
        draft.contentFolders = action.payload;
        break;
      case UPDATE_CONTENT_FILES:
        draft.contentFiles = action.payload;
        break;

      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentFolder = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentFolder = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentFolder = {};
        break;
      // Add
      case ADD_FOLDER:
        draft.isSubmitting = true;
        break;
      case ADD_FOLDER_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_FOLDER_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_FOLDER:
        draft.isSubmitting = true;
        break;
      case EDIT_FOLDER_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_FOLDER_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_FOLDER:
        draft.isDeleting = true;
        break;
      case DELETE_FOLDER_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_FOLDER_FAILURE:
        draft.isDeleting = false;
        break;
      case UPLOAD_FILE:
        draft.isUploadingFile = true;
        break;
      case UPLOAD_FILE_SUCCESS:
        draft.isUploadingFile = false;
        break;
      case UPLOAD_FILE_FAILURE:
        draft.isUploadingFile = false;
        break;
      case VALIDATE_FILE:
        draft.isValidatingFile = true;
        break;
      case VALIDATE_FILE_SUCCESS:
        draft.isValidatingFile = false;
        break;
      case VALIDATE_FILE_FAILURE:
        draft.isValidatingFile = false;
        break;
      default:
        return state;
    }
  });

export default FolderReducer;
